import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import { doDeletePrestacionSel, openCloseModalEliminarPrestacionSel } from "./action";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";

class ModalDelete extends React.PureComponent {
  handleCancel = () => {
    this.props.dispatch(openCloseModalEliminarPrestacionSel(false, {}));
  }

  handleEliminar = () => {
    this.props.dispatch(doDeletePrestacionSel(this.props.prestacion));
  }

  render() {
    return (
      <Popup
        title="Eliminar prestación"
        showCloseButton
        dragEnabled={false}
        onHiding={this.handleCancel}
        visible={this.props.isOpenModalEliminarPrestacion}
        width={500}
        height={200}
        contentComponent={() => (
          <div className="modal-delete-mantenedor">
            {this.props.isLoading && <LoadingOverlay />}
            Esta acción es irreversible.
            <br />
            ¿Estás seguro de eliminar la prestación?
            <div className="button-row">
              <div>
                <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleCancel} />
              </div>
              <div>
                <Button text="Eliminar" type="danger" onClick={this.handleEliminar} useSubmitBehavior />
              </div>
            </div>
          </div >
        )
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isOpenModalEliminarPrestacion: state.mantenedorPrestacionesSel.isOpenModalEliminarPrestacion,
  prestacion: state.mantenedorPrestacionesSel.prestacion,
  isLoading: state.mantenedorPrestacionesSel.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalDelete);
